export default __webpack_public_path__ + "static/app-school-525b0d4187c6ebdad1199e244b18ae95.png";